// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"12":"Embed","556":"Popup"}[chunkId] || chunkId) + "." + {"12":"a555aae2","278":"86c0ac3c","556":"cdacf633","838":"4c8e9106","885":"2961e1b2"}[chunkId] + ".chunk.js";
};